import React, { PropTypes, Component } from 'react';
import styled from 'styled-components';
import { NitroText } from 'nitro-components';

import CarToolTip from './CarToolTip';
import CarIcon from './CarIcon';

const CAR_HEIGHT = 34;
const CAR_WIDTH = 118;

const IndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const IndicatorHolder = styled.div`
  margin-bottom: 30px;
  position: relative;
  text-align: center;
  width: 100%;
`;

const CarHolder = styled.div`
  background-color: ${props => props.theme.color.white};
  padding-left: 10px;
  padding-right: 10px;
  display: inline-block;
  position: relative;
  z-index: 20;

  svg {
    height: ${CAR_HEIGHT}px;
    width: ${CAR_WIDTH}px;
  }
`;

const IndicatorMarker = styled.div`
  position: absolute;
  top: ${CAR_HEIGHT / 2}px;
  left: ${props => props.position}%;
  transform: translateX(-50%);
  text-align: center;

  &::before {
    display: block;
    width: 1px;
    height: 15px;
    margin: 18px auto 3px;
    content: '';
    background-color: ${props => props.theme.color[props.color || 'border']}
  }

  &::after {
    display: block;
    position: absolute;
    top: -4px;
    left: 50%;
    width: 16px;
    height: 16px;
    transform: translateX(-50%);
    content: '';
    border-radius: 50%;
    background-color: ${props => props.theme.color[props.color || 'border']}
  }
`;

const IndicatorLine = styled.div`
  position: absolute;
  top: ${CAR_HEIGHT / 2}px;
  width: 100%;
  height: 8px;
  background: linear-gradient(
    to right,
    ${props => props.theme.color.primary} 0%,
    ${props => props.theme.color.primary} 50%,
    ${props => props.theme.color.border} 50%
  );
  z-index: 10;

  ${props => props.hideLeft && `
    background: linear-gradient(
      to right,
      transparent 0%,
      transparent 50%,
      ${props.theme.color.border} 50%
    );
  `};

  ${props => props.hideRight && `
    background: linear-gradient(
      to right,
      ${props.theme.color.primary} 0%,
      ${props.theme.color.primary} 50%,
      transparent 50%
    );
  `};
`;

class LeaseIndicator extends Component {

  getMarkerPositions() {
    const { current, total } = this.props;

    // Lease has just started
    if (current === 0) {
      return [{
        color: 'primary',
        label: '0',
        distance: 50
      }];
    }

    // Lease has ended
    if (current === total) {
      return [{
        color: 'primary',
        label: total,
        distance: 50
      }];
    }

    const markerSpacing = total > 6 ? total / 6 : 2;
    const firstMarker = (current - markerSpacing) > 0 ?
      Math.round(current - markerSpacing) : 0;
    const secondMarker = (current + markerSpacing) < total ?
      Math.round(current + markerSpacing) : total;

    return [{
      color: 'primary',
      label: firstMarker,
      distance: 15
    }, {
      color: 'border',
      label: secondMarker,
      distance: 85
    }];
  }

  render() {
    const { current, total } = this.props;

    const positions = this.getMarkerPositions();

    const markers = positions.map(position => (
      <IndicatorMarker
        key={`indicator-marker-${position.distance}`}
        color={position.color}
        position={position.distance}
      >
        <NitroText variant={position.color} size={3}>
          {position.label} mo
        </NitroText>
      </IndicatorMarker>
    ));

    return (
      <IndicatorContainer>
        <CarToolTip
          animationDelay={100}
          current={current}
          total={total}
        />
        <IndicatorHolder>
          <CarHolder>
            <CarIcon />
          </CarHolder>
          {markers}
          <IndicatorLine
            hideLeft={current === 0}
            hideRight={current === total}
          />
        </IndicatorHolder>
      </IndicatorContainer>
    );
  }
}

LeaseIndicator.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
};

export default LeaseIndicator;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileTabs/LeaseIndicator.js